import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './MessagesTopicsTableHead.scss';

export const MESSAGES_TOPICS_TABLE_HEADER = [
  {
    label: 'topicStatus',
    sortBy: 'status'
  },
  {
    label: 'subject',
    sortBy: 'subject'
  },
  // {
  //   label: 'lastMessageAuthor'
  // },
  {
    label: 'ownerOperator'
  },
  {
    label: 'customer'
  },
  {
    label: 'customerStatus'
  },
  {
    label: 'lastMessageSentDate',
    sortBy: 'last_message_sent_at'
  }
];

const MessagesTopicsTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {MESSAGES_TOPICS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'messages-topics-table-head'}>
              <div className={'messages-topics-table-head-block'}>
                <span>{i18n.getMessage(`messages.topics.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`messages-topics-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

MessagesTopicsTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default MessagesTopicsTableHead;
